export default "/images/vendor/flag-icon-css/flags/1x1/ir.svg?7fdcd500420537104db1bb953fbbcfca";